export default __webpack_public_path__ + "static/media/career-bg_min.98f6165e.webp";